import { useUser } from "@/stores";

// What to do on a 401. Each app registers its own (the public app routes to
// /login); importing the router here would drag the whole public app into
// the separately built admin bundle.
let onUnauthorized = () => window.location.assign("/login");
export function setUnauthorizedHandler(handler) {
  onUnauthorized = handler;
}

function createApiDefaults() {
  return new Promise((resolve) => {
    const userStore = useUser();
    userStore.getUser().then((user) => {
      if (!user) {
        resolve({});
      } else {
        user.getIdToken().then((token) => {
          if (!token) {
            resolve({});
          } else {
            resolve({
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
          }
        });
      }
    });
  });
}

function updateOptions(options = {}) {
  return new Promise((resolve) => {
    const update = {
      ...options,
      body: options.files ? options.files : JSON.stringify(options.body),
    };

    // public calls skip the auth lookup so they don't wait on firebase init
    const defaultsPromise = options.public
      ? Promise.resolve({})
      : createApiDefaults();

    defaultsPromise
      .then((defaults) => {
        update.headers = {
          ...defaults.headers,
          ...update.headers,
          Accept: "application/json",
          ...(options.body && { "Content-Type": "application/json" }),
          "country-locale-code": "en-US",
        };

        resolve(update);
      })
      .catch((err) => {
        console.log("err", err);
      });
  });
}

function api(url, options = {}) {
  return new Promise((resolve, reject) => {
    const query = "?" + new URLSearchParams(options.query).toString();
    updateOptions(options).then((updatedOptions) => {
      fetch(
        import.meta.env.VITE_APP_API_BASE_URL +
          url +
          (options.query ? query : ""),
        updatedOptions
      ).then(async (res) => {
        // 429: rate limited (public reviewer endpoints); reject so callers
        // don't treat the {error} body as data
        if ([401, 404, 400, 422, 409, 403, 429].includes(res.status)) {
          if (res.status === 401 && !options.skipAuthRedirect) {
            useUser().user = null;
            // console.log("401, just cleared user in api");
            onUnauthorized();
          }

          try {
            const data = await res.json();
            if (window.location.pathname === "/") return;
            // window location doesn't work in this context
            // window.location = "/no-plan";
            return reject({
              status: res.status,
              data,
            });
          } catch {
            return reject({
              status: res.status,
              data: null,
            });
          }
        }

        try {
          return resolve({
            status: res.status,
            data: await res.json(),
          });
        } catch {
          return resolve({
            status: res.status,
            data: null,
          });
        }
      }, reject); // network failure: settle instead of leaving callers hanging
    });
  });
}

export default api;
